<template>
  <div class="detail-contents-space">
    <h4 class="title title-brline">
      <span class="title-txt-left">{{ title }}</span>
    </h4>

    <div v-if="id === 'Webhook'" class="title title-txt-left">
      <div v-html="converted"></div>
    </div>

    <template>
      <template v-for="data of parsed">
        <template v-for="ref of data.methods">
          <DetailComponent
            :data="data.refValue[ref]"
            :dataMethod="ref"
            :dataUrl="data.url"
            :parameters="data.refValue.parameters"
            :title="title"
          ></DetailComponent>
        </template>
      </template>
    </template>

    <!-- PayLoad 자리 -->
    <div v-if="id === 'Webhook'" class="title title-txt-left"></div>
  </div>
</template>

<script>
// Components
import DetailComponent from '../components/DetailComponent';

// Functions
import { userParser, managerParser } from '../data/userData';
import MarkdownIt from 'markdown-it';

export default {
  name: 'Detail',
  components: {
    DetailComponent,
  },
  props: {
    id: String,
    userDoc2: Object,
    managerDoc2: Object,
  },
  mounted() {
    if (this.id !== 'Webhook') return;
    const $h2 = document.querySelectorAll('h2');
    const imitations = $h2[0].innerText;
    $h2[0].innerHTML = `<a id="Webhook-Limitations" style="padding-top: 65px;"></a>${imitations}`;
    const payload = $h2[1].innerText;
    $h2[1].innerHTML = `<a id="Webhook-Payload" style="padding-top: 65px;"></a>${payload}`;
    const trigger = $h2[2].innerText;
    $h2[2].innerHTML = `<a id="Webhook-Event-Triggers" style="padding-top: 65px;"></a>${trigger}`;
  },
  computed: {
    parsed() {
      if (this.$route.params.pilot === 'ユーザー') {
        return userParser(this.userDoc2, this.$route.params.id);
      } else if (this.$route.params.pilot === '管理者') {
        return managerParser(this.managerDoc2, this.$route.params.id);
      }
    },
    title() {
      return this.$route.params.id;
    },
    converted() {
      const md = new MarkdownIt();
      const webhook = this.userDoc2.tags.filter(
        (item) => item.name === 'Webhook',
      );
      let converted = md.render(webhook[0].description);
      converted = converted.replaceAll('&lt;br&gt;', '<br>');
      return converted;
    },
  },
};
</script>

<style scoped lang="scss">
.detail-contents-space {
  margin: 2.5rem 3rem;
}

.title {
  font-family: Meiryo, sans-serif;
  margin: 0;
  margin: 0rem 1rem;
}

.title-brline {
  font-size: 36px;
  font-weight: 500;
  color: #151f26;
  line-height: 1.5;
  border-bottom: 2px solid #eceef1;
}

.title-txt-left {
  padding-left: 7px;
  ::v-deep p > code {
    color: rgb(229, 57, 53);
    background-color: rgba(38, 50, 56, 0.05);
    font-family: Courier, monospace;
    border-radius: 2px;
    border: 1px solid rgba(38, 50, 56, 0.1);
    padding: 0px 5px;
    font-size: 13px;
    font-weight: 400;
    word-break: break-word;
  }
  ::v-deep pre {
    font-family: Courier, monospace;
    background-color: rgb(17, 23, 26);
    color: white;
    padding: 20px;
    overflow-x: auto;
    line-height: normal;
    border-radius: 0px;
    border: 1px solid rgba(38, 50, 56, 0.1);
    code {
      color: rgb(160, 251, 170);
    }
  }
  ::v-deep table {
    border: 1px solid #444444;
    border-collapse: collapse;
    th,
    td {
      border: 1px solid #444444;
    }
  }
  ::v-deep hr {
    border: 1px solid #eceef1;
  }
}
</style>
